module.exports = __webpack_public_path__ + "assets/images/crate-step3.67ddedfe.jpg";